import { useState } from "react";
import store from "../../../../redux/store";
import { useEffect } from "react";



const WardListFilterFunctions = (props) => {
    let storedFilters = store.getState().WardListFilters.filters;

    const defaultFilters = {
        wardStatus: storedFilters && storedFilters.wardStatus ? storedFilters.wardStatus : null,
        sortByAlpha: storedFilters && storedFilters.sortByAlpha ? storedFilters.sortByAlpha : null,
    };
    const [filters, setFilters] = useState(defaultFilters);
    const [WardStatus, setWardListStatusList] = useState([
        {
            title: "Active",
            value: 1,
            checked: false,
            id: 1,
        },
        {
            title: "Inactive",
            value: 0,
            checked: false,
            id: 2,
        },
    ]);

    const [SortByList, setSortByListStatusList] = useState([
        {
            title: "Ascending",
            value: "ASC",
            checked: false,
            id: 1,
        },
        {
            title: "Decending",
            value: "DESC",
            checked: false,
            id: 2,
        },
    ]);


    useEffect(() => {
        if (storedFilters && storedFilters.sortByAlpha) {
            reSetValuesOfSortByAlphaStatusList(storedFilters.sortByAlpha);
        }
    }, [storedFilters]);


    useEffect(() => {
        if (storedFilters && storedFilters.wardStatus) {
            reSetValuesOfWardStatusList(storedFilters.wardStatus);
        }
    }, [storedFilters]);


    const reSetValuesOfSortByAlphaStatusList = (appliedStatus) => {
        let array = [...SortByList]
        if (appliedStatus) {
            const appliedSortByStatusIndex = array.findIndex((data) => parseInt(data.id) === parseInt(appliedStatus.id));
            if (appliedSortByStatusIndex !== -1) {
                array[appliedSortByStatusIndex].checked = true
            }
            setSortByListStatusList(array)
        }
    };


    const reSetValuesOfWardStatusList = (appliedStatus) => {
        let array = [...WardStatus]
        if (appliedStatus) {
            const appliedWardStatusIndex = array.findIndex((data) => parseInt(data.id) === parseInt(appliedStatus.id));
            if (appliedWardStatusIndex !== -1) {
                array[appliedWardStatusIndex].checked = true
            }
            setWardListStatusList(array)
        }
    };


    const handleWardStatusFilters = (item) => {
        let array = [...WardStatus]
        if (item) {
            for (let i in array) {
                array[i].checked = false
            }
            let index = array.findIndex((data) => parseInt(data.id) === parseInt(item.id));
            if (index !== -1) {
                let check = array[index].checked
                array[index].checked = !check
            }
            setWardListStatusList(array);
            setFilters({
                ...filters,
                wardStatus: item
            })
        }
    };



    const handleSortByFilters = (item) => {
        let array = [...SortByList]
        if (item) {
            for (let i in array) {
                array[i].checked = false
            }
            let index = array.findIndex((data) => parseInt(data.id) === parseInt(item.id));
            if (index !== -1) {
                if (array[index].checked === true) {
                    array[index].checked = false
                }
                else {
                    array[index].checked = true
                }
            }
            setSortByListStatusList(array);
            setFilters({
                ...filters,
                sortByAlpha: item
            })
        }
    };


    const applyFilters = () => {
        props.applyFilters(filters);
    };


    const handleClearAllFilters = () => {
        props.handleClearAllFilters();
        props.close();
    };


    return {
        WardStatus,
        setSortByListStatusList,
        SortByList,
        handleWardStatusFilters,
        handleSortByFilters,
        setFilters,
        filters,
        applyFilters,
        handleClearAllFilters
    }
};

export default WardListFilterFunctions;